module.exports = __webpack_public_path__ + "img/1f9a9.c7a5770.svg";